import Axios from 'axios';
import header from './auth/header';

const API_URL = process.env.API_URL + '/api/v1/';
const API_URLV3 = process.env.API_URL + '/api/v3/';

class MitraProfile {
  index() {
    return Axios.get(API_URL + 'mitraprofile-list', { headers: header() });
  }

  show(mitraprofile) {
    return Axios.get(API_URL + `mitraprofile/${mitraprofile}`, { headers: header() });
  }

  update(data) {
    return Axios.patch(API_URL + 'update-mitraprofile', data, { headers: header() });
  }

  updateV3(data) {
    return Axios.patch(API_URLV3 + 'mitra/profile', data, { headers: header() });
  }

  mitraProfile() {
    return Axios.get(API_URL + 'mitra-profile', { headers: header() });
  }

  countsNotif() {
    return Axios.get(API_URL + 'counts', { headers: header() });
  }
}

export default new MitraProfile();



// WEBPACK FOOTER //
// ./src/api/mitraprofile.js